import React, { memo, Fragment } from 'react'
import {
  useInnerTitleSection,
  InnerTitleSectionProps,
} from './useInnerTitleSection'
import { Link } from 'react-router-dom'
import styles from './InnerTitleSection.module.scss'

const InnerTitleSection: React.FC<InnerTitleSectionProps> = (
  props: InnerTitleSectionProps
) => {
  const { title, breadcrumbs } = useInnerTitleSection(props)

  return (
    <section className={styles['page-title']}>
      <div className={styles.heading}>
        <div className='container'>
          <div className='row d-flex justify-content-center text-center'>
            <div className='col-lg-8'>
              <h1>{title}</h1>
            </div>
          </div>
        </div>
      </div>

      <nav className={styles.breadcrumbs}>
        <div className='container'>
          <ol>
            {breadcrumbs?.length ? (
              breadcrumbs.map((breadcrumb, index) =>
                breadcrumb.link ? (
                  <li key={`breadcrumb-${index}`}>
                    <Link to={breadcrumb.link}>{breadcrumb.title}</Link>
                  </li>
                ) : (
                  <li key={`breadcrumb-${index}`}>
                    <span className={styles.text}>{breadcrumb.title}</span>
                  </li>
                )
              )
            ) : (
              <Fragment />
            )}
          </ol>
        </div>
      </nav>
    </section>
  )
}

export default memo(InnerTitleSection)
